<template>
  <div class="bg-white">
    <form
      @submit="handleSubmit"
      method="post"
      action="https://localhost:8999/trialSignUp"
    >
      <div>
        <label for="name" class="block">
          Name
        </label>
        <input type="text" name="name" id="name" v-model="name" />
      </div>
      <div>
        <label for="emailAddress" class="block">Email</label>
        <input
          type="email"
          name="emailAddress"
          id="emailAddress"
          class="w-full min-w-md p-2"
          v-model="email"
        />
      </div>
      <div>
        <label for="password" class="block">Password</label>
        <input
          type="password"
          name="password"
          id="password"
          v-model="password"
        />
      </div>

      <input type="hidden" value="Aspire Trial" name="product" />
      <input type="hidden" name="termsAndConditions" value="true" />
      <input type="hidden" name="marketingEmails" value="false" />
      <input type="input" name="captchaResponse" v-model="captchaResponse" />
      <input type="submit" value="Submit" />
    </form>
    <input type="button" value="Get Captcha" @click="getCaptcha"/>
  </div>
</template>

<script>
export default {
  name: "RecaptchTest",
  data() {
    return {
      name: "Adam James",
      email: "adamjames87+captcha1@gmail.com",
      password: "",
      captchaResponse: ""
    };
  },
  methods: {
    getCaptcha() {
      const vm = this;
      window.grecaptcha.ready(function() {
        window.grecaptcha
          .execute("6LdWu8IUAAAAAO1fzITAAKVIfk95It1d22B2PBIL", {
            action: "submit"
          })
          .then(function(token) {
            // Add your logic to submit to your backend server here.
            alert(token);
            vm.captchaResponse = token;
          });
      });
    },
    handleSubmit() {
      // Get the captcha stuff
      // let data1 = {
      //   name: this.name,
      //   emailAddress: this.email,
      //   password: this.password,
      //   termsAndConditions: true,
      //   marketingEmails: false,
      //   product: "Aspire",
      //   captchaResponse: null
      // };
      return true;
    }
  }
};
</script>

<style scoped></style>
